/**
 * Общая разметка форм входа, регистрации и восстановления пароля.
 *
 * Формы живут на разных страницах, но выглядят одинаково: одна карточка по
 * центру, поля с подписью и ошибкой снизу. Держать это в одном месте дешевле,
 * чем повторять в четырёх. Общие для них хуки и helper'ы — в `lib/authForm.ts`.
 */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="mx-auto max-w-md py-8">
      <div className="panel p-7">
        <h1 className="font-sans text-3xl text-ink-50">{title}</h1>
        <p className="mt-1.5 text-sm text-ink-400">{subtitle}</p>
        <div className="mt-6">{children}</div>
        {footer && (
          <div className="mt-6 border-t border-ink-800 pt-4 text-center">{footer}</div>
        )}
      </div>
    </div>
  );
}

export function Field({
  label,
  error,
  children,
}: {
  label: string;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <span className="label">{label}</span>
      {children}
      {error && <p className="mt-1 text-xs text-rust">{error}</p>}
    </div>
  );
}

export function FormError({ children }: { children: React.ReactNode }) {
  return (
    <p className="rounded-xl border border-rust/40 bg-rust/10 px-3 py-2 text-sm text-rust">
      {children}
    </p>
  );
}
